var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.563,
    viewBox: "0 0 16 16.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Next",
    transform: "translate(-1435.5 -504.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7192",
    "data-name": "Path 7192",
    d: "M0,0,7.947,6.962,0,13.742",
    transform: "translate(1442.553 506.073)",
    fill: "none",
    stroke: "#032d66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7193",
    "data-name": "Path 7193",
    d: "M13,0H0",
    transform: "translate(1436.5 512.944)",
    fill: "none",
    stroke: "#032d66",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.24bdb3f978d09e302a8c140a2efbb1ec.svg";
export { ForwardRef as ReactComponent };